export default __webpack_public_path__ + "static/media/miguel-lopes-13.1e461021.jpg";